export const VALIDATION_MAX_FILE_SIZE = 8 * 1024 * 1024;

export const VALIDATION_REPORT_TYPES = [
  { value: 'complete', label: 'Report tabellare completo' },
  { value: 'analytics-social', label: 'Analytics Social' },
  { value: 'web-gsuite', label: 'Web / GSuite' },
] as const;

export type ValidationReportType = typeof VALIDATION_REPORT_TYPES[number]['value'];

type WorkbookCandidate = {
  name: string;
  size: number;
};

export function validateValidationWorkbook(file: WorkbookCandidate): string | null {
  if (!/\.xlsx?$/i.test(file.name)) {
    return 'Carica un file Excel in formato .xlsx o .xls.';
  }

  if (file.size === 0) {
    return 'Il file selezionato è vuoto.';
  }

  if (file.size > VALIDATION_MAX_FILE_SIZE) {
    return 'Il file supera il limite di 8 MB.';
  }

  return null;
}

export function validationReportTypeLabel(value: ValidationReportType): string {
  return VALIDATION_REPORT_TYPES.find((item) => item.value === value)?.label ?? value;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
